import { render, staticRenderFns } from "./AtcFormAddButton.vue?vue&type=template&id=5571a55b&scoped=true&"
import script from "./AtcFormAddButton.vue?vue&type=script&lang=js&"
export * from "./AtcFormAddButton.vue?vue&type=script&lang=js&"
import style0 from "./AtcFormAddButton.vue?vue&type=style&index=0&id=5571a55b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5571a55b",
  null
  
)

export default component.exports